import styles from "./Toolbar.styles";
import React from "react";
import './ToolbarButton.css'
import {useSelector} from "react-redux";
import {getTurnColorPlayer} from "../../utils/players/getTurnColorPlayer";
import {checkIfCentralQuarter} from "../../utils/buildings/checkIfCentralQuarter";
import CentralQuarterIcon from "./CentralQuarterIcon/CentralQuarterIcon";
import {checkIfFlag} from "../../utils/buildings/checkIfFlag";
import FlagIcon from "./FlagIcon/FlagIcon";
import {HexButtonFrame} from "../gameUi/HexButton";
import {joinClassNames} from "../gameUi/joinClassNames";
import {getPlayerColorStyle} from "../../utils/gameUi/getPlayerColorStyle";

export function ToolbarButton(props) {
  const {
    tokenId,
    disabled,
    selected,
    image,
    label,
    onClick,
    imgClassName,
    children,
  } = props;

  // В режиме планирования — цвет самого игрока, а не ходящего
  // (см. getTurnColorPlayer)
  const colorPlayer = useSelector(getTurnColorPlayer);

  let content
  if (checkIfFlag(tokenId)) {
    content = <FlagIcon token={tokenId}/>
  } else if (checkIfCentralQuarter(tokenId)) {
    content = <CentralQuarterIcon token={tokenId}/>
  } else {
    content = <img
      className={imgClassName}
      src={image}
      alt={label}
      style={styles.tokenImage}
    />
  }
  // Гекс-кнопка дизайн-системы матча: жетон как на поле, выбранный
  // приподнят и обведен рамкой цвета игрока (cell-icon — метка выбора для
  // обучения и тестов)
  return <button
    className={joinClassNames(
      'gui-hex-button',
      'toolbar-button',
      selected && 'gui-hex-button_selected',
      disabled && 'gui-hex-button_disabled',
      disabled && 'icon-button-disabled',
    )}
    style={getPlayerColorStyle(colorPlayer?.color)}
    onClick={onClick}
    title={label}
    aria-pressed={selected}
  >
    {content}
    {selected ? <HexButtonFrame className={'cell-icon'}/> : null}
    {children}
  </button>;
}
